import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useEffect, useCallback } from "react";
import { UseFormReturn } from "react-hook-form";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { ModalContainer } from "../../../../../../common/components/modal_container";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { ItemFolhaPagamentoVerbaForm } from "../../../schemas/FolhaPagamento_itensverba/item_folha_pagamento_verba";
import { ItemVerbaFuncionarioDropDown } from "../../../../domain/models/item_verba_funcionario_dropdown";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * CadastroItemFolhaPagamentoModal
 */

type Props = {
  open: boolean,
  saving: boolean,
  itensVerbaFuncionario: ItemVerbaFuncionarioDropDown[],
  reactHookForm: UseFormReturn<ItemFolhaPagamentoVerbaForm>,
  onSubmit: (form: ItemFolhaPagamentoVerbaForm) => void,
  onClose: () => void,
};

export const CadastroItemFolhaPagamentoVerbaModal = ({
  open,
  saving,
  itensVerbaFuncionario,
  reactHookForm,
  onSubmit,
  onClose,
}: Props) => {

  useEffect(() => {
    if (open) reactHookForm.reset();
  }, [
    reactHookForm,
    open,
  ]);

  const handleSubmit = useCallback((form: ItemFolhaPagamentoVerbaForm) => {
    if (!saving) onSubmit(form);
  }, [
    saving,
    onSubmit,
  ]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [
    saving,
    onClose,
  ]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: reactHookForm.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>

      <DialogTitle>
        Cadastrar Verba
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <ModalContainer>
            <FormContainer title={"Informações"} arrangement="fullRow" border={false}>
              <>
                <DefaultFormMultiAutocomplete
                  name='idItensVerbaFuncionario'
                  label='Verbas'
                  required={true}
                  options={itensVerbaFuncionario}
                  getOptionKey={x => x.idItemVerbaFuncionario}
                  getOptionLabel={x => x.descricao}
                  reactHookForm={reactHookForm} />

              </>
            </FormContainer>
          </ModalContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex px-4 pb-4 gap-4">
          <div></div>

          <div className="flex flex-row">
            <div className="flex flex-row gap-2">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={handleClose}>
                  Cancelar
                </h1>
              </div>

              <div className="w-[120px]">
                {saving ? (
                  <PrimaryButton
                    buttonColor="primary-green">
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    buttonColor="primary-green">
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}